import React, { useContext } from 'react'
import { useAppContext } from 'src/containers/AppContext'
import { getProductButtonProps } from 'src/utils/product'
import { AddToCart as AddToCartElement } from '@jarvis.oddle/core/molecules/ProductDetailsModal'
import { useStoreItemAvailability } from 'src/containers/StoreItemAvailability'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import useAppSelector from 'src/hooks/useAppSelector'
import { selectDetailMenuSite } from 'src/redux/meta'
import { selectOrder } from '../../../../redux/order'

interface AddToCartProps {
  formatMoney?: (x: number) => number
  totalQuantity?: number
  totalItemPrice?: number
  productState?: Menu.MenuItem
  category?: Menu.MenuData
}

const AddToCart = React.memo(
  ({
    totalItemPrice,
    totalQuantity,
    productState: product,
    category
  }: AddToCartProps): JSX.Element => {
    const { t } = useContext(TranslationContext)
    const { formatMoney } = useAppContext()
    const metaState = useAppSelector(selectDetailMenuSite)
    const { enableTimeLimitUnavailability } = metaState?.features || {}
    const {
      text: productButtonText,
      disabled,
      loading
    } = getProductButtonProps(
      t,
      product,
      category,
      useStoreItemAvailability({ product, category }),
      enableTimeLimitUnavailability
    )
    const totalPrice = totalItemPrice * totalQuantity

    return (
      <AddToCartElement
        withInput
        disabled={!totalQuantity || disabled}
        buttonText={
          disabled
            ? String(productButtonText)
            : String(
                t(`Add _totalPrice_`, { totalPrice: formatMoney(totalPrice) })
              )
        }
        loading={loading}
      />
    )
  }
)

export default AddToCart
